export default {
  masterpass: require("./am_masterpass.png"),
  applepay: require("./am_applepay.png"),
  payPal: require("./am_payPal.png"),
  visaCheckout: require("./am_visaCheckout.png"),
  wechat: require("./am_weChat.png"),
  alipay: require("./am_alipay.png"),
  payconiq: require("./am_payconiq.png"),
};
